import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=35c976b0&"
import script from "./InputForm.vue?vue&type=script&lang=ts&"
export * from "./InputForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports